import React, { useEffect, useRef, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const PrivateOfferSpinner = ({ duration = 10, onComplete }) => {
  const [percentage, setPercentage] = useState(0);
  const startRef = useRef(null); // timestamp when animation started
  const rafRef = useRef(null); // requestAnimationFrame id

  useEffect(() => {
    const totalDuration = Math.max(0.001, duration) * 1000; // ms, avoid zero
    // reset start timestamp so animation restarts cleanly
    startRef.current = null;

    // cancel any running animation before starting a new one
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    }

    const step = (timestamp) => {
      if (!startRef.current) startRef.current = timestamp;
      const elapsed = timestamp - startRef.current;
      let progress = elapsed / totalDuration;

      if (progress >= 1) {
        progress = 1;
      }

      setPercentage(progress * 100);

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        rafRef.current = null;
        if (typeof onComplete === 'function') onComplete();
      }
    };

    // start animation
    rafRef.current = requestAnimationFrame(step);

    // cleanup: cancel on unmount or if dependencies change
    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, [duration, onComplete]); // restart if duration or onComplete changes

  const size = window.innerWidth > 600 ? 309 : 200;

  return (
    <div style={{ width: `${size}px`, height: `${size}px` }}>
      <CircularProgressbar
        value={percentage}
        strokeWidth={8}
        styles={buildStyles({
          rotation: 0, // keep your original starting point
          circleRatio: 1, // important — make the drawable path the full circle
          strokeLinecap: 'round',
          pathTransitionDuration: 0, // we're driving animation manually
          pathColor: '#6C2AD2',
          trailColor: '#D9D9D9',
          textColor: '#000',
        })}
      />
    </div>
  );
};

export default PrivateOfferSpinner;
